import React from "react";
import * as XLSX from "xlsx";
import config from "../config";

const Export = ({ onExport, student, teacher, mcq, bank }) => {
  const handleExport = () => {
    if (onExport) {
      const exportData = onExport();
      if (exportData) {
        const ws = XLSX.utils.json_to_sheet(exportData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");
        XLSX.writeFile(
          wb,
          `${
            student
              ? "students ("
              : teacher
              ? "Teachers ("
              : mcq
              ? "MCQ - " + mcq + " (MCQ Bank - " + bank + ") ("
              : "("
          }${Date().slice(4, 24)}).xlsx`
        );
      }
    }
  };

  return (
    <button
      className="btn btn-outline-dark"
      data-toggle="tooltip"
      title="Export to XLSX"
      onClick={handleExport}
    >
      <span className={`${config.export_icon}`}></span>
    </button>
  );
};

export default Export;
